import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQueryCriticalPathRemovedTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['criticalPathRemovedTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
